export var ADDRESS_FINDER_LOCAL_URL = 'http://localhost:8081';
export var ADDRESS_FINDER_DEV_URL = 'https://address-finder-dev.retail-azure.js-devops.co.uk';
export var ADDRESS_FINDER_TEST_URL = 'https://address-finder-test.retail-azure.js-devops.co.uk';
export var ADDRESS_FINDER_PREPROD_URL = 'https://address-finder-preprod.retail-azure.js-devops.co.uk';
export var ADDRESS_FINDER_PROD_URL = 'https://address-finder.sainsburys.co.uk';